import { FieldType } from '@indigohive/cogfy-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu } from '../../../../components'
import { FieldsMenu } from './subcomponents/FieldsMenu'
import { SearchInput } from '../../components/SearchInput'
import { GetOperationsResultData } from '@indigohive/cogfy-types/endpoints/getOperations'

export type CreateFieldMenuProps = {
  operations?: GetOperationsResultData[]
  onClick?: (fieldType: FieldType, fieldOperation?: string, displayName?: string) => void
}

const FIELD_TYPES_BY_CATEGORY: FieldType[][] = [
  [
    'text',
    'number',
    'boolean',
    'select',
    'date',
    'file',
    'reference'
  ],
  [
    'chat',
    'chatMessage',
    'connection'
  ],
  [
    'author',
    'lastEditor',
    'createDate',
    'updateDate'
  ],
  [
    'json',
    'vector',
    'httpResponse',
    'schedule'
  ],
  [
    'nuvemFiscal.nfse',
    'sendgrid.inboundEmail',
    'stripe.customer',
    'vindi.bill',
    'vindi.customer',
    'vindi.subscription'
  ]
]

export function CreateFieldMenu (props: CreateFieldMenuProps) {
  const { operations, onClick } = props

  const [searchFieldName, setSearchFieldName] = useState('')
  const { t } = useTranslation()

  return (
    <Menu className="max-h-[70vh] overflow-y-hidden max-w-full w-80">
      <div>
        <li className="menu-title text-base-content">
          {t('New field')}
        </li>
        <SearchInput
          searchName={searchFieldName}
          className="m-2"
          onNameChange={setSearchFieldName}
        />
      </div>

      <FieldsMenu
        fieldTypesByCategory={FIELD_TYPES_BY_CATEGORY}
        operations={operations ?? []}
        searchFieldName={searchFieldName}
        onClick={onClick}
      />
    </Menu>
  )
}
